exports.tokenize = tokenizeListStart;
exports.continuation = {
  tokenize: tokenizeListContinuation
};
exports.exit = tokenizeListEnd;

var markdownSpace = require('../character/markdown-space');

var asciiDigit = require('../character/ascii-digit');

var prefixSize = require('../util/prefix-size');

var sizeChunks = require('../util/size-chunks');

var thematicBreak = require('./thematic-break');

var createSpace = require('./factory-space');

var blank = require('./partial-blank-line');

function tokenizeListStart(effects, ok, nok) {
  var self = this;
  var initialSize = prefixSize(self.events, 'linePrefix');
  var valueSize;
  return start;

  function start(code) {
    if ((code === 42 || code === 43 || code === 45) && (!self.containerState.marker || code === self.containerState.marker)) {
      return code === 42 || code === 45 ? effects.check(thematicBreak, nok, unordered)(code) : unordered(code);
    }

    if (asciiDigit(code) && (!self.containerState.type || self.containerState.type === 'listOrdered')) {
      return ordered(code);
    }

    return nok(code);
  }

  function unordered(code) {
    if (!self.containerState.type) {
      self.containerState.type = 'listUnordered';
      effects.enter(self.containerState.type, {
        _container: true
      });
    }

    effects.enter('listItemPrefix');
    return atMarker(code);
  }

  function ordered(code) {
    if (self.containerState.type || !self.interrupt || code === 49) {
      if (!self.containerState.type) {
        self.containerState.type = 'listOrdered';
        effects.enter(self.containerState.type, {
          _container: true
        });
      }

      effects.enter('listItemPrefix');
      effects.enter('listItemValue');
      effects.consume(code);
      valueSize = 1;
      return self.interrupt ? afterValue : inside;
    }

    return nok(code);
  }

  function inside(code) {
    if (asciiDigit(code) && ++valueSize < 10) {
      effects.consume(code);
      return inside;
    }

    return afterValue(code);
  }

  function afterValue(code) {
    effects.exit('listItemValue');
    return code === 41 || code === 46 ? atMarker(code) : nok(code);
  }

  function atMarker(code) {
    self.containerState.marker = self.containerState.marker || code;

    if (code === self.containerState.marker) {
      effects.enter('listItemMarker');
      effects.consume(code);
      effects.exit('listItemMarker');
      return effects.check(blank, // Can’t be empty when interrupting.
      self.interrupt ? nok : onBlank, effects.attempt({
        tokenize: tokenizeListItemPrefixWhitespace,
        partial: true
      }, endOfPrefix, otherPrefix));
    }

    return nok(code);
  }

  function onBlank(code) {
    self.containerState.initialBlankLine = true;
    initialSize++;
    return endOfPrefix(code);
  }

  function otherPrefix(code) {
    if (markdownSpace(code)) {
      effects.enter('listItemPrefixWhitespace');
      effects.consume(code);
      effects.exit('listItemPrefixWhitespace');
      return endOfPrefix;
    }

    return nok(code);
  }

  function endOfPrefix(code) {
    self.containerState.size = initialSize + sizeChunks(self.sliceStream(effects.exit('listItemPrefix')));
    return ok(code);
  }
}

function tokenizeListContinuation(effects, ok, nok) {
  var self = this;
  self.containerState._closeFlow = undefined;
  return effects.check(blank, onBlank, notBlank);

  function onBlank(code) {
    self.containerState.furtherBlankLines = self.containerState.furtherBlankLines || self.containerState.initialBlankLine;
    return ok(code);
  }

  function notBlank(code) {
    if (self.containerState.furtherBlankLines || !markdownSpace(code)) {
      self.containerState.furtherBlankLines = self.containerState.initialBlankLine = undefined;
      return notInCurrentItem(code);
    }

    self.containerState.furtherBlankLines = self.containerState.initialBlankLine = undefined;
    return effects.attempt({
      tokenize: tokenizeIndent,
      partial: true
    }, ok, notInCurrentItem)(code);
  }

  function notInCurrentItem(code) {
    // While we do continue, we signal that the flow should be closed.
    self.containerState._closeFlow = true; // As we’re closing flow, we’re no longer interrupting

    self.interrupt = undefined;
    return createSpace(effects, effects.attempt(exports, ok, nok), 'linePrefix', 4)(code);
  }
}

function tokenizeIndent(effects, ok, nok) {
  var self = this;
  return createSpace(effects, afterPrefix, 'listItemIndent', self.containerState.size + 1);

  function afterPrefix(code) {
    return prefixSize(self.events, 'listItemIndent') === self.containerState.size ? ok(code) : nok(code);
  }
}

function tokenizeListEnd(effects) {
  effects.exit(this.containerState.type);
}

function tokenizeListItemPrefixWhitespace(effects, ok, nok) {
  var self = this;
  return createSpace(effects, afterPrefix, 'listItemPrefixWhitespace', 4 + 1);

  function afterPrefix(code) {
    return markdownSpace(code) || !prefixSize(self.events, 'listItemPrefixWhitespace') ? nok(code) : ok(code);
  }
}